import { createTheme, Theme } from '@mui/material/styles';

import { ThemeType } from 'shared/interfaces';

export const setupTheme = (themeSettings: ThemeType): Theme => {
    return createTheme({
        palette: {
            primary: {
                main: themeSettings.primaryColor,
            },
            secondary: {
                main: themeSettings.secondaryColor,
            },
            background: {
                default: themeSettings.backgroundColor,
            },
        },
        typography: {
            fontSize: 14,
            fontFamily: 'Altice',
            h2: {
                fontSize: '4.5rem',
                fontWeight: 'bold',
                color: themeSettings.primaryColor,
            },
            h3: {
                fontSize: '3rem',
                fontWeight: 'bold',
                color: themeSettings.primaryColor,
            },
            h4: {
                fontSize: '1.75rem',
                fontWeight: 'bold',
                color: themeSettings.secondaryColor,
            },
            h5: { fontSize: '1.5rem', color: themeSettings.secondaryColor },
            button: { fontSize: '1.5rem', textTransform: 'none' },
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    html: {
                        fontSize: 14,
                        fontFamily: 'Altice',
                    },
                    body: {
                        margin: '0',
                        boxSizing: 'border-box',
                        fontFamily: 'Altice',
                        backgroundColor: themeSettings.backgroundColor,
                    },
                },
            },
            MuiButton: {
                variants: [
                    {
                        props: { variant: 'primary' },
                        style: {
                            border: `2px solid ${themeSettings.primaryButton.borderColor}`,
                            borderRadius: `${themeSettings.buttonRadius}px`,
                            backgroundColor:
                                themeSettings.primaryButton.backgroundColor,
                            color: themeSettings.primaryButton.fontColor,
                            ':hover': {
                                border: `2px solid ${themeSettings.primaryButton.borderColor}`,
                                borderRadius: `${themeSettings.buttonRadius}px`,
                                backgroundColor:
                                    themeSettings.primaryButton.backgroundColor,
                                color: themeSettings.primaryButton.fontColor,
                            },
                            ':disabled': {
                                backgroundColor: 'rgba(0, 0, 0, 0.12)',
                                color: 'rgba(0, 0, 0, 0.26)',
                            },
                        },
                    },
                    {
                        props: { variant: 'secondary' },
                        style: {
                            border: `2px solid ${themeSettings.secondaryButton.borderColor}`,
                            borderRadius: `${themeSettings.buttonRadius}px`,
                            backgroundColor:
                                themeSettings.secondaryButton.backgroundColor,
                            color: themeSettings.secondaryButton.fontColor,
                            ':hover': {
                                border: `2px solid ${themeSettings.secondaryButton.borderColor}`,
                                borderRadius: `${themeSettings.buttonRadius}px`,
                                backgroundColor:
                                    themeSettings.secondaryButton
                                        .backgroundColor,
                                color: themeSettings.secondaryButton.fontColor,
                            },
                            ':disabled': {
                                backgroundColor: 'rgba(0, 0, 0, 0.12)',
                                color: 'rgba(0, 0, 0, 0.26)',
                            },
                        },
                    },
                ],
            },
            MuiSwitch: {
                styleOverrides: {
                    switchBase: {
                        // Controls default (unchecked) color for the thumb
                        color: '#ffffff',
                    },
                    colorPrimary: {
                        '&.Mui-checked': {
                            // Controls checked color for the thumb
                            color: themeSettings.primaryButton.backgroundColor,
                        },
                        '&.Mui-checked&.Mui-disabled': {
                            color: '#ccc',
                        },
                        '&.Mui-disabled': {
                            color: '#ccc',
                        },
                    },
                    track: {
                        // Controls default (unchecked) color for the track
                        opacity: 0.7,
                        backgroundColor: '#fff',
                        '.Mui-checked.Mui-checked + &': {
                            // Controls checked color for the track
                            opacity: 0.7,
                            backgroundColor:
                                themeSettings.primaryButton.backgroundColor,
                        },
                        '.Mui-checked.Mui-disabled + &': {
                            opacity: 0.5,
                            backgroundColor: '#ccc',
                        },
                        '.Mui-disabled.Mui-disabled+&': {
                            opacity: 0.5,
                            backgroundColor: '#ccc',
                        },
                    },
                },
            },
        },
    });
};
